import React from "react";

import { AgenciesBody } from "@src/features/admin/pages/agencies/Agencies.body";

import { useViewPage } from "../../../../hooks/mixpanel";

export const AgenciesRoute = () => {
  useViewPage("admin/agencies");

  return <AgenciesBody />;
};
